<template>
  <div class="anticon" :class="getAppLogoClass">
    <img
      :src="$ossUrl + store.getters.getConfig.www_logo_src"
      style="width: auto; height: auto; max-width: 90%; max-height: 90%"
    />
    <div :class="titileClass" class="ml-2 truncate md:opacity-100" >
      {{ store.getters.getConfig.name }}
    </div>
  </div>
</template>
<script>
  import store from '@/store/index';
  export default {
    components: {},
    data() {
      return {
        store: store,
        titileClass:"www2-app-logo__title",
        getAppLogoClass:"www2-app-logo"
      };
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>
<style lang="less" scoped>
  @import '../../assets/less/breakpoint.less';
  @namespace: 'www2';
  @prefix-cls: ~'@{namespace}-app-logo';

  .@{prefix-cls} {
    display: flex;
    align-items: center;
    padding-left: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &.light {
      border-bottom: 1px solid @border-color-base;
    }

    &.collapsed-show-title {
      padding-left: 20px;
    }

    &.light &__title {
      color: @primary-color;
     
    }

    &.dark &__title {
      color: @white;
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      transition: all 0.5s;
      line-height: normal;
      
    }
  }
</style>
